<template>
    <layout title="Credit Request">
        <form @submit.prevent="handleSubmit">
            <page-header>
                <template #title>Credit Request</template>

                <template #actions>
                </template>
            </page-header>

            <div class="flex flex-col px-3 md:px-4 lg:px-8 gap-y-4">
                <refund-details
                    :form="form"
                    :order="order"
                    :isCreate=true
                    :refund=null
                />
    
                <refund-products 
                    :form="form"
                    :ordered_products="order_products"
                />
            </div> 

            <div class="text-center py-24" >                
                <div class="flex justify-center gap-x-8">
                    <jet-button type="submit" class="leading-none" style="padding-left: 2rem; padding-right: 2rem; padding-top: 1rem; padding-bottom: 1rem; font-size: 1rem;">
                        Submit
                    </jet-button>
                </div>
            </div>
        </form>
    </layout>
</template>

<script>
import { useForm } from '@inertiajs/inertia-vue3';
import Layout from '@/Pages/Refund/NoAuth/Layout.vue';
import PageHeader from '@/Layouts/partials/PageHeader.vue';
import RefundDetails from '@/Pages/Refund/Partials/RefundDetails.vue';
import JetButton from '@/Jetstream/Button';
import JetTertiaryButton from '@/Jetstream/TertiaryButton';
import RefundProducts from '@/Pages/Refund/Partials/RefundProducts.vue';

export default {
    setup(props) {
        const form = useForm({
            itemsToReturn: {},
            itemReason: {},
            qtyToAdd: {},
            itemImages: {},
            returnNote: {},
            receiptImage: null,
        })

        return { form }
    },

    props: [ 
        'order',
        'order_products' 
    ],

    components: {
        Layout,
        PageHeader,
        RefundDetails,
        JetButton,
        JetTertiaryButton,
        RefundProducts,
    },

    data() {
        return {
            formRoute: this.route('outlet.refunds.store'),
        }
    },

    methods: {
        handleSubmit () {
            if(!this.form.processing){
                this.form
                    .transform((data) => ({
                        ...data,
                        token: this.order.refund_token,
                    }))
                    .post(route('refunds.store'));
            }
        },
        
        closeWindow() {
            window.close();
        },
    },
}
</script>

<style scoped>
.multi-custom {
    min-height: 1.5rem;
}
</style>
